__webpack_require__.p = "/static/cmp-spa/";